import { useQuery } from 'react-query';

import { useApiContext } from 'context/ApiContext';
import { KEYS } from 'helpers/react-query.config';

const useGetUserPerms = (id: number) => {
  const { security: securityApi } = useApiContext();

  const getAccessList = useQuery(
    [KEYS.security.GetAccessList(), id],
    () => securityApi.accounts.GetAccessList(),
    {
      refetchOnWindowFocus: false,
      select: (data) => data?.data?.data
    }
  );

  return {
    getAccessList
  };
};

export default useGetUserPerms;
